import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IntegerOnlyDirective } from './input-Integer-number.directive';
import { TooltipDirective } from './tooltip.directive';

@NgModule({
  declarations: [TooltipDirective,IntegerOnlyDirective],
  imports: [CommonModule],
  exports: [TooltipDirective,IntegerOnlyDirective] 
})
export class CustomDirectivesModule { }
